export default __webpack_public_path__ + "static/medgas_panel_b.e15bbd75b0c9408754e7b43b63843788.png";